<template>
  <v-container>
    <v-subheader class="title" id="environments__main-title">
      <v-icon x-large class="mr-2">mdi-domain</v-icon>
      {{ $t("modules.environments.title") }}
    </v-subheader>
    <v-divider></v-divider>
    <div v-if="isPermitted(PermissionEnum.ENVIRONMENTS.VIEW)">
      <current-environment></current-environment>
      <environments-action></environments-action>
      <environments-table></environments-table>
    </div>
    <div v-else class="grey--text">
      <v-container fill-height>
        <v-layout align-center>
          <v-flex text-xs-center>
            <div>
              <v-icon size="50" color="grey">mdi-alert</v-icon>
            </div>
            <h3 class="display-1 font-weight-light">
              {{ $t("validation.notPermitted") }}
            </h3>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <status-message></status-message>
  </v-container>
</template>

<script>
import EnvironmentsTable from "./components/environments-table";
import EnvironmentsAction from "./components/environments-action";
import CurrentEnvironment from "./components/current-environment";
import StatusMessage from "@/components/status-message";
import { permissionMixin } from "@/mixins/permissions";

export default {
  name: "EnvironmentsPage",
  mixins: [permissionMixin],
  components: {
    EnvironmentsTable,
    EnvironmentsAction,
    CurrentEnvironment,
    StatusMessage
  },

  created() {
    this.$store.commit("snackbar/toggleMessage", false);
  }
};
</script>
